import { v4 as uuidv4 } from 'uuid';

export function ProductDescription(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductDescription',
		componentId: uuidv4(),
		props: Object.assign(
			{
				collapseContent: true,
				showTitle: true,
				title: '',
			},
			props,
		),
		childrenComponents,
	};
}
